export interface BatchType {
    id?: number;
    name?: string;
    description?: string;
    is_active?: string;
}

export const defaultBatchTypeDataForm: BatchType = {
    name: '',
    description: ''
};

export interface BatchTypeFilters {
    id?: number | null;
    name?: string | '';
    is_active?: boolean | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
